import React, { useState } from 'react';
import "../../../resources/RTCC/css/common/radio_box_style.css";
import icon_car from '../../../resources/RTCC/icon_car.PNG';
import icon_pin from '../../../resources/RTCC/icon_pin.PNG';
import { Button } from '../../atoms/RTCC/button';
import { ModalOptionForm } from '../../molecules/RTCC/modalOptionForm';
import './../../../resources/RTCC/css/reservation/reservation.css';

export const PlanList = (props) => {
    const { hotelListWrapperName, planListWrapperName, planWrapperName, hotelList, isWideTablet,
        planListStyle, hotelImgStyle, handleHotelDetail, handlePlanDetail, handleReserve, handleErrorHotel, handleErrorPlan } = props;

    const [displayAllPlanFlg, setDisplayAllPlanFlg] = useState({});
    const handleAllPlan = (index) => {
        const newState = {
            ...displayAllPlanFlg,
        };
        newState[index] = !newState[index];
        setDisplayAllPlanFlg(newState);
    }
    const planContents = (hotel, plan) => <div key={plan.planId} className={planWrapperName}>
        <div style={plan.lc_flg ? styles.luxuryCollection : { display: "none" }}>💎LUXURY COLLECTION</div>
        <img
            src={plan.roomImages}
            style={{ display: "none" }}
            onError={e => {
                e.target.parentElement.style.display = "none";
                handleErrorPlan(hotel.hotelId, plan.planId);
            }}
        />
        <div style={{ fontWeight: "bold" }}>{plan.planName}</div>
        <div style={styles.planDescriptions}>{plan.planDescriptions}</div>
        <div style={isWideTablet ? { display: "block", alignItems: "center" } : { display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={styles.feeLabel}>
                    旅行代金
                </div>
                <div style={styles.fee}>
                    ¥{Number(plan.fee).toLocaleString()}
                </div>
            </div>
            <div style={{ display: "flex" }}>
                <Button
                    wrapClassName="planDetailWrapLong"
                    className="planDetailBtn"
                    onClick={() => handlePlanDetail(hotel.hotelId, plan.planId)}
                    buttonText={"プラン詳細"}
                    buttonClassName="serachBtnText"
                    tabIndex="17"
                />
                <Button
                    buttonText="予約する"
                    className="btnReservationResult"
                    onClick={() => handleReserve(hotel.hotelId, plan.planId, plan.roomName)}
                    buttonClassName="serachBtnText"
                    tabIndex="18"
                />
            </div>
        </div>
    </div>;

    return (
        <div style={planListStyle}>
            {hotelList.map((hotel, index) => (
                <div key={hotel.hotelId + index} style={hotel.planList.length != 0 ? { marginBottom: "40px" } : { display: "none" }}>
                    <img
                        src={hotel.propertyImages}
                        style={hotelImgStyle}
                        onError={e => {
                            e.target.parentElement.style.display = "none";
                            handleErrorHotel(index);
                        }}
                    />
                    <div className={hotelListWrapperName}>
                        <div className="hotelName"> {hotel.hotelName}</div>
                        <div className="addressArea">
                            <img src={icon_pin} style={styles.iconPin} />
                            {hotel.address}
                        </div>
                        <div className={hotel.access ? "accessArea" : "hiddenItem"}>
                            <img src={icon_car} style={styles.iconCar} />
                            {hotel.access}
                        </div>
                        <Button
                            className="hotelDetailBtn"
                            onClick={() => handleHotelDetail(hotel.hotelId)}
                            buttonText={"ホテルの詳細はこちら"}
                            buttonClassName="serachBtnText"
                            tabIndex="16"
                        />
                    </div>
                    <div className={planListWrapperName}>
                        <div className="planNumLabel" >プラン一覧（{hotel.planList.length}件）</div>
                        {displayAllPlanFlg[index] ? hotel.planList.map((plan, index) => (planContents(hotel, plan)))
                            : hotel.planList.filter((plan, planIndex) => planIndex < 2).map((plan, index) => (planContents(hotel, plan)))}
                        <div className={hotel.planList.length > 2 ? "btnAllPlanWrap" : "hiddenItem"}>
                            <Button
                                buttonText={displayAllPlanFlg[index] ? "表示プランを減らす" : "すべてのプランを見る"}
                                className={displayAllPlanFlg[index] ? "btnOmitPlan" : "btnAllPlan"}
                                onClick={() => handleAllPlan(index)}
                                buttonClassName="serachBtnText"
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

const styles = {
    luxuryCollection: {
        display: "block",
        marginBottom: "16px",
        color: "white",
        backgroundColor: "#c1ab05",
        height: "20px",
        width: "180px",
        textAlign: "center",
        alignItems: "center",
        fontSize: "small"
    },
    feeLabel: {
        whiteSpace: "nowrap",
        color: "gray",
        fontSize: "small",
    },
    fee: {
        fontWeight: "bold",
        padding: "0px 16px",
        fontSize: "large",
        whiteSpace: "nowrap",
    },
    planDescriptions: {
        padding: "10px 0px",
        fontSize: "small",
    },
    iconPin: {
        width: "24px",
        height: "30px",
        paddingRight: "2px"
    },
    iconCar: {
        width: "24px",
        height: "20px",
        paddingRight: "2px"
    }
}